<template>
  <div>
    <div v-if="isLoading" class="loader-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    <div class=" container-fluid">
      <div class="llp-container-section  heightcontainer ">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div id="deals" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
          <div>
            <nav class="navbar navbar-expand-lg  bg-info text-white">
              <span><b>Quotes</b></span>
            </nav>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm"> Days Back </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <select name="source" v-model.trim="daysBackSent" class="form-control input-sm" @change="getQuoteIds">
                  <option disabled value=""> Select a Source </option>
                  <option v-for="(option, index) in daysBack" :value="option.days" :key="index">{{ option.days }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="salesAgent" class="col-form-label col-form-label-sm"> Select Quote# </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <multiselect style="width:100%" name="saleagent" @input="getQuoteByQuoteId" v-model="selectQuote"
                  :options="quoteIdsList" :value="quoteIdsList.quoteId" label="quoteId" selected="selected"
                  id="customersdd">
                </multiselect>
              </div>
            </div>
            <!-- <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Automatic Quote</b>
              </span>
            </nav>
            <center>
              <span :style="msgcolor">{{ uploadingMessage }}</span>
            </center>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label class="col-form-label col-form-label-sm">Upload</label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input ref="fileInput" type="file" class="form-control input-sm" @change="onFileSelected" id="uploadfile" accept=".xlsx,.xls,.xlsm" />
                <span class="alert-danger">{{ uploadErrorMessage }}</span>
              </div>
              <div class="col-12 col-md-12 justify-content-lg-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <button :disabled='selectedFile == null' class="btn btn-secondary uploadBtn" style="font-size: 14px" @click="onUpload">
                  Upload
                </button>
              </div>
            </div> -->
            <div v-if="openCustomerSection" data-vv-scope="customerDetails">
              
            <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Customer Demographics</b></span></nav>
            <center>
        <span :style="msgcolor">
          <b>{{message}}</b>
        </span>
      </center>
            <br>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <input type="radio" class="mr-1" name="customerType"  value="P" id="P" v-model.trim="customer.customerType" @change="logType" />Personal</div>
             <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <input type="radio" class="mr-1" name="customerType"  value="B" id="B" v-model.trim="customer.customerType" @change="logType" />Business</div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="prefixddlabel" class="col-form-label col-form-label-sm">Prefix</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 align-items-center ">
                  <select id="prefixdd" v-model.trim="customer.selectedUserPrefixCode"  class="form-control input-sm " >
                     <option value="">Select a Prefix...</option>
                     <option v-for="(option, index) of userprefixs" :value="option.userPrefixC" :key="index">
                        {{ option.userPrefixX }}
                     </option>
                  </select>

               </div> <!--col end-->
            </div><!--row end-->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center" >
                  <label id="fnamelabel" class="col-form-label col-form-label-sm required">First Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="fname"
                     placeholder="Enter First Name"
                     v-model.trim="customer.firstName"  class="form-control input-sm"
                     size="11"
                     v-validate="'required'"
                     data-vv-name="First Name"
                     maxlength="50"
                     data-vv-scope="customerDetails"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('First Name')" class="alert-danger">{{ errors.first('First Name') }}</div>
               </div><!--col end-->
               <!-- <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"   v-if="customer.customerType === 'B'">
                  <label id="fnamelabel" class="col-form-label col-form-label-sm">First Name</label>
               </div> -->
               <!--col end-->
               <!-- <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"  v-if="customer.customerType === 'B'">
                  <input id="fname"
                     placeholder="Enter First Name"
                     v-model.trim="customer.firstName"
                     size="11"
                     class="form-control input-sm"
                     data-vv-name="First Name"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('First Name')" class="alert-danger" > {{ errors.first('First Name') }} </div>
               </div> -->
               <!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="mnamelabel" class="col-form-label col-form-label-sm" >Middle Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="mname"
                     placeholder="Enter Middle Name"
                     name="source"
                     v-model.trim="customer.middleName"
                     class="form-control input-sm"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="lnamelabel" class="col-form-label col-form-label-sm">Last Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input  id="lname"
                     placeholder="Enter Last Name"
                     v-model.trim="customer.lastName"
                     class="form-control input-sm"
                     data-vv-name="Last Name"
                     maxlength="50"
                     data-vv-scope="customerDetails"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('Last Name')" class="alert-danger" > {{ errors.first('Last Name') }} </div>
               </div><!--col end-->
            </div><!--row end-->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2" v-if="customer.customerType === 'B'">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="fnamelabel" class="col-form-label col-form-label-sm required">Business Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="Bname"
                     placeholder="Enter Business Name"
                     v-model.trim="customer.businessName"
                     class="form-control input-sm"
                     v-validate="'required'"
                     size="20"
                     data-vv-name="Business Name"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('Business Name')" class="alert-danger" > {{ errors.first('Business Name') }} </div>
               </div><!--col end-->
            </div><!--row end-->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2" >
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="adr1label" class="col-form-label col-form-label-sm">Address Line1</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="adr1"
                     placeholder="Enter Address1"
                     v-model.trim="customer.addressLine1"
                     class="form-control input-sm"
                     maxlength="50"/>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="adr2label" class="col-form-label col-form-label-sm">Address Line2</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="adr2"
                     placeholder="Enter Address2"
                     v-model.trim="customer.addressLine2"
                     class="form-control input-sm"
                     maxlength="50"/>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="citylabel" class="col-form-label col-form-label-sm">City</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="city"
                     placeholder="Enter City"
                     v-model.trim="customer.city"
                     class="form-control input-sm"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
               </div><!--col end-->
            </div><!--row end-->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="statesddlabel" class="col-form-label col-form-label-sm">State</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                 <!-- <select id="statesdd"
                     class="form-control input-sm"
                     v-model="customer.selectedStateCode"
                     >
                     <option value="">Select a State...</option>
                     <option v-for="(option,index) in states" :value="option.stateFipsC" :key="index">
                        {{ option.stateN }}
                     </option>
                  </select> -->
                  <multiselect
    style="width:100%; color: #777;"
    v-model="customer.selectedStateCode"
    :options="states"
    placeholder="Select a State..."
    :value="states.stateFipsC"
     label="stateN"
    selected="selected"
    id="statesdd">
  </multiselect>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="zipcodelabel" class="col-form-label col-form-label-sm required">Zip Code</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input  id="zipcode"
                     placeholder="Enter 5 Digit zip"
                     title="Please enter 5 digits"
                     v-model="customer.zipCode"
                    @input="zipDecoder"
                     class="form-control input-sm"
                     maxlength="5"
                     v-validate="{required: true, regex: /^(\d)(?!\1+$)/, digits:5 }"
                     data-vv-name="Zip Code"
                     onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"/>
                  <div v-if="errors.has('Zip Code')" class="alert-danger" > {{ errors.first('Zip Code') }} </div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="countrylabel" class="col-form-label col-form-label-sm">Country</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="country"
                     placeholder="Enter Country"
                     class="form-control input-sm"
                     v-model="customer.countryName"
                     disabled="true"/>
               </div><!--col end-->
            </div><!--row end-->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"> <label id="emaillabel" class="col-form-label col-form-label-sm">Email</label> </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="email"
                     placeholder="Enter email"
                     v-model.trim="customer.emailId"
                     class="form-control input-sm"
                     v-validate="'email'"
                     data-vv-name="Email" ref="emailref"
                     maxlength="50"/>
                  <div v-if="errors.has('Email')" class="alert-danger" > {{ errors.first('Email') }} </div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="pnumlabel" class="col-form-label col-form-label-sm">Cell/Primary Phone</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                   <input
            id="pnum"
            placeholder="Enter Mobile Number"
            v-model="customer.mobileNumber"
            class="form-control input-sm"
            title="Please enter 10 digits"
            maxlength="10"
            v-validate="'min:10|max:14'"
            data-vv-name="Cell Phone"
            @input="formatCellPhoneNumber"
            @blur="formatCellPhoneNumber"
          />
          <div v-if="errors.has('Cell Phone')" class="alert-danger">{{ errors.first('Cell Phone') }}</div>
          <div v-if="this.fraudMobileError !=''" class="alert-danger">{{fraudMobileError}}</div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="pnumlabel" class="col-form-label col-form-label-sm" v-if="customer.mobileNumber!=''">Fraud Cell</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-if="customer.mobileNumber!=''">
                  <select
            name="fraudIndicator"
            placeholder="Select fraudIndicator"
            v-model.trim="customer.fraudCell"
            data-vv-as="indicator"
            @change="changeFraudInd"
            class="form-control input-sm"
          >
            <option
              v-for="indicator in fraudIndicatorList"
              v-bind:key="indicator.key"
            >{{indicator.keyValue}}</option>
          </select>
          <div
            v-if="errors.has('Fraud Cell Phone')"
            class="alert-danger"
          >{{ errors.first('Fraud Cell Phone') }}</div>

               </div><!--col end-->

            </div><!--row end-->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                   <label id="wnumlabel" class="col-form-label col-form-label-sm">Secondary Phone</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="wnum"
                     placeholder="Enter Work Number"
                     v-model="customer.workNumber"
                     class="form-control input-sm"
                     title="Please enter 10 digits"
                     maxlength="10"
                     v-validate="'min:10|max:14'" data-vv-name="Work Phone"
                     @input="formatWorkPhoneNumber"
                     @blur="formatWorkPhoneNumber"
                     />
                             <div v-if="errors.has('Work Phone')" class="alert-danger">{{ errors.first('Work Phone') }}</div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                   <label id="fnumlabel" class="col-form-label col-form-label-sm">Fax #</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="fnum"
                     placeholder="Enter Fax Number"
                     v-model="customer.faxNumber"
                     class="form-control input-sm"
                     title="Please enter 10 digits"
                     maxlength="10"
                     v-validate="'min:10|max:14'" data-vv-name="Fax"
                     @input="formatFaxNumber"
                     @blur="formatFaxNumber"
                     />
                  <div v-if="errors.has('Fax')" class="alert-danger">{{ errors.first('Fax') }}</div>
               </div><!--col end-->
            </div><!--row end-->

            <div v-show="false" class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="pcontactddlabel" class="col-form-label col-form-label-sm">Preferred Contact</label>
                </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select id="pcontactdd"
                     v-model="customer.preferredContactCode"
                     class="form-control input-sm"
                     disabled="disabled">
                     <option v-for="(option,index) of preferredContactOptions" :value="option.value" :key="index">
                        {{ option.text }}
                     </option>
                  </select>
               </div><!--col end-->
            </div>

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end">
                  <label id="statusddlabel" class="col-form-label col-form-label-sm">Status</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select id="statusdd" v-model="customer.selectedStatusCode" class="form-control input-sm">
                     <option v-for="(option,index) in statusOptions" :value="option.value" :key="index">{{ option.text }}</option>
                  </select>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end">
        <label for="priority" class="col-form-label col-form-label-sm"> New Eligibility Flag </label>
        </div><!--col end-->
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
        <select  name="fraudIndicator"  v-model.trim="customer.fraudInd" data-vv-as="indicator" class="form-control input-sm" @change="eligibilityFlag">
          <option v-for="(indicator,index) in fraudIndicatorList" v-bind:key="indicator.key">{{indicator.keyValue}} </option>
        </select>
        </div><!--col end-->
        <div class="col-12 col-md-12 d-flex justify-content-lg-end">
        <label for="priority" class="col-form-label col-form-label-sm required" v-if="customer.fraudInd == 'N' || customer.fraudCell == 'Y' || customer.fraudInd == 'R'"> Reg Flag Reason </label>
        </div><!--col end-->
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-if="customer.fraudInd == 'N' || customer.fraudCell == 'Y' || customer.fraudInd == 'R'">
         <select v-model.trim="customer.redFlagReason" v-validate="'required'"  name="Red Flag Reason" data-vv-name="Red Flag Reason" class="form-control input-sm">
            <option disabled value="">Select Redflag Reason</option>
            <option
              v-for="(indicator,index) in redFlagReasonList"
              v-bind:key="index"
            >{{indicator.keyValue}}</option>
          </select>
          <div v-if="errors.has('Red Flag Reason')" class="alert-danger">{{errors.first('Red Flag Reason')}} </div>
        </div><!--col end-->
            </div><!--row end-->

            <br/>
            <div>
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center">
                  <div class="center ">
                     <!-- <button class="btn btn-secondary" type="submit" @click="saveCustomerData">Save</button> -->
                  </div>
               </div>
            </div>
            <br><br>
            <!-- End of the code for this screen here -->
         </div>
            <nav class="navbar navbar-expand-lg  bg-info text-white">
              <span><b>Generate Quote</b></span>
            </nav>
            <center><span :style="msgcolor"><b>{{ information }}</b></span></center>
            <div v-if="this.quote.customerFraudReason != null"
              class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="quoteDate" class="col-form-label col-form-label-sm"> Quote Date </label>
              </div>
              <div class="col-12 col-md-12 d-flex align-items-center">
                <label for="quoteDate" class="col-form-label col-form-label-sm"> {{ quote.quoteDate |
                  moment("MM/DD/YYYY") }} </label>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div v-if="this.quote.customerFraudReason == null"
                class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="quoteDate" class="col-form-label col-form-label-sm"> Quote Date </label>
              </div>
              <div v-if="this.quote.customerFraudReason == null" class="col-12 col-md-12 d-flex align-items-center">
                <label for="quoteDate" class="col-form-label col-form-label-sm"> {{ quote.quoteDate |
                  moment("MM/DD/YYYY") }} </label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="proposedLessee" v-if="!openCustomerSection" class="col-form-label col-form-label-sm required"> Lessee Name </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <multiselect style="width:100%" name="proposedLessee" v-validate="'required'" v-if="!openCustomerSection"
                  v-model="quote.selectedCustomerId" :options="customersList" :value="customersList.customerId"
                  :custom-label="displayFullName" @input="getFraudCustomer(quote.selectedCustomerId.customerId)"
                  selected="selected" id="customersdd">
                </multiselect>
                <div v-if="errors.has('proposedLessee')" class="alert-danger">{{ errors.first('proposedLessee') }}</div>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                v-if="this.quote.customerFraudReason != null">
                <label class="col-form-label col-form-label-sm">Lessee Fraud Reason</label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-start align-items-center"
                v-if="this.quote.customerFraudReason != null && this.quote.customerFraudReason != 'Review'">
                <label style="background-color:Red;text-align:center; float:left"
                  class="col-form-label col-form-label-sm">{{ quote.customerFraudReason }}</label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-start align-items-center"
                v-if="this.quote.customerFraudReason != null && this.quote.customerFraudReason == 'Review'">
                <label style="background-color:Orange;text-align:center; float:left"
                  class="col-form-label col-form-label-sm">{{ quote.customerFraudReason }}</label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="salesAgent" class="col-form-label col-form-label-sm required"> Underwriter Name </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <multiselect style="width:100%" name="creditAnalyst" data-vv-as="Credit Analyst Name"
                  v-model="quote.selectedCreditAnalystId" :options="creditAnalystList" v-validate="'required'"
                  :value="creditAnalystList.employeeId" :custom-label="displayAgentFullName" selected="selected"
                  id="creditAnalyst">
                </multiselect>
                <div v-if="errors.has('creditAnalyst')" class="alert-danger">{{ errors.first('creditAnalyst') }}</div>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="salesAgent" class="col-form-label col-form-label-sm required"> Salesperson Name </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <multiselect style="width:100%" name="salesperson" data-vv-as="Salesperson"
                  v-validate="'required_if:source,Dealer'" v-model="quote.selectedEmployeeId"
                  :options="agentList" :value="agentList.employeeId" :custom-label="displayAgentFullName"
                  selected="selected" id="salesperson">
                </multiselect>
                <div v-if="errors.has('salesperson')" class="alert-danger">{{ errors.first('salesperson') }}</div>
              </div>

              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm required"> Source </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <select name="source" ref="source" v-model.trim="quote.source" v-validate="'required'"
                  class="form-control input-sm" data-vv-as="Source" @change="updateDealer">
                  <option disabled value=""> Select a Source </option>
                  <option v-for="(option, index) in sources" :value="option.sourceName" :key="index">{{
                  option.sourceName
                }}</option>
                </select>
                <div v-if="errors.has('source')" class="alert-danger">{{ errors.first('source') }}</div>
              </div>
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label for="dealerName" class="col-form-label col-form-label-sm"> Dealer Name </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <multiselect style="width:100%" name="proposedLessee" v-model="quote.selectedDealerId"
                  :options="sortedDealers" :value="sortedDealers.dealerId" :custom-label="displayDealerFullName"
                  selected="selected" id="customersdd" @input="getFraudDealer(quote.selectedDealerId.dealerId)">
                </multiselect>
              </div>

            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label for="leaseType" class="col-form-label col-form-label-sm"> Lease Type </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <select name="leaseType" v-model.trim="quote.leaseType" class="form-control input-sm">
                  <option disabled value=""> Select a Lease Type </option>
                  <option v-for="(option, index) in leaseTypes" :value="option.type" :key="index">{{ option.type }}
                  </option>
                </select>
              </div>

              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="loanAmount" class="col-form-label col-form-label-sm"> Loan Amount </label>
              </div>
              <div class="col-12 col-md-12   justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <input type="Text" name="loanAmount" data-vv-as="Loan Amount" v-validate="'decimal'"
                  class="form-control input-sm" v-model.trim="quote.loanAmount"
                  onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))" />
                <div v-if="errors.has('loanAmount')" class="alert-danger">{{ errors.first('loanAmount') }}</div>
              </div>
              <div v-if="this.quote.dealerFraudReason === null"
                class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label class="col-form-label col-form-label-sm"> Terms </label>
              </div>
              <div v-if="this.quote.dealerFraudReason === null"
                class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <input type="Text" name="terms" data-vv-as="Terms" v-validate="'between:2,60'"
                  class="form-control input-sm" v-model.trim="quote.terms" maxlength="2"
                  onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))" />
                <div v-if="errors.has('terms')" class="alert-danger">{{ errors.first('terms') }}</div>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                v-if="this.quote.dealerFraudReason != null">
                <label class="col-form-label col-form-label-sm">Dealer Fraud Reason</label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-start align-items-center"
                v-if="this.quote.dealerFraudReason != null && this.quote.dealerFraudReason != 'Review' && this.quote.dealerFraudReason != 'NA'">
                <label style="background-color:Red"
                  class="col-form-label col-form-label-sm">{{ quote.dealerFraudReason }}</label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-start align-items-center"
                v-if="this.quote.dealerFraudReason != null && this.quote.dealerFraudReason == 'NA'">
                <label style="background-color:Yellow" class="col-form-label col-form-label-sm">Reason not available</label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-start align-items-center"
                v-if="this.quote.dealerFraudReason != null && this.quote.dealerFraudReason == 'Review'">
                <label style="background-color:Orange"
                  class="col-form-label col-form-label-sm">{{ quote.dealerFraudReason }}</label>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div v-if="this.quote.dealerFraudReason !== null"
                class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label class="col-form-label col-form-label-sm"> Terms </label>
              </div>
              <div v-if="this.quote.dealerFraudReason !== null"
                class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <input type="Text" name="terms" data-vv-as="Terms" v-validate="'between:2,60'"
                  class="form-control input-sm" v-model.trim="quote.terms" maxlength="2"
                  onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))" />
                <div v-if="errors.has('terms')" class="alert-danger">{{ errors.first('terms') }}</div>
              </div>
              <template v-if="quote.source === 'InHouse'">
                <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                  <label for="InhouseName" class="col-form-label col-form-label-sm"> Inhouse Values</label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select name="InhouseName" v-model.trim="quote.inHouseName" class="form-control input-sm">
                    <option disabled value=""> Select a Inhouse value </option>
                    <option v-for="(option, index) in inhouseList" :value="option.inhouseValue" :key="index">{{
                  option.inhouseValue }}</option>
                  </select>
                </div>
              </template>
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center"> <label id="custTypedd"
                  class="col-form-label col-form-label-sm"> Customer Type</label> </div>
              <div class="col justify-content-end align-items-center">
                <label for="year" class="col-form-label col-form-label-sm"> {{ customerType | formatCustType }} </label>
              </div>
            </div>
            <div id="myModal" class="modal">
              <div class="modal-content">
                <div class="modal-header">
                  <h2>Fraud Alert</h2>
                </div>
                <div class="modal-body">
                  There is fraud block. To continue, override provide supervisor
                </div>
                <br>
                <div class="modal-footer"><button class="btn-blue-save nextButton" @click="fraudoverride()">OK</button>
                </div>
              </div>
            </div>
            <div id="reviewAlert" class="modal">
              <div class="modal-content">
                <div class="modal-header">
                  <h2>Review Alert</h2>
                </div>
                <div class="modal-body">
                  There is fraud block. To continue, override provide supervisor
                </div>
                <br>
                <div class="modal-footer"><button class="btn-blue-save nextButton" @click="fraudoverride()">OK</button>
                </div>
              </div>
            </div>
            <div id="vinDecoder" class="modal">
              <div class="modal-content">
                <div class="modal-header">
                  <h2>No Vehicle Found</h2>
                </div>
                <div class="modal-body">
                  {{ vehicleInfoMessage }}
                </div>
                <br>
                <div class="modal-footer"><button class="btn-blue-save nextButton" @click="clearVIN()">OK</button>
                </div>
              </div>
            </div>
            <div id="vinBlacklist" class="modal">
              <div class="modal-content">
                <div class="modal-header">
                  <h2>VIN BlackListed</h2>
                </div>
                <div class="modal-body">
                  {{ blackListInfoMessage }}
                </div>
                <br>
                <div class="modal-footer"><button class="btn-blue-save nextButton" @click="clearDialog()">OK</button>
                </div>
              </div>
            </div>
            <!-- <div id="customerInfo" class="modal">
              <div class="modal-content dialogContent">
                <div class="modal-header">
                  <h2>Customer does not exist</h2>
                </div>
                <div class="modal-body text-center">
                  
                  {{ customerInfoMessage }}
                </div>
                <br>
                <div class="modal-footer createCustModal my-2">
                  <button class="btn-blue-save custBtn mr-2" @click="cancelCustomerReg()">Proceed With Exisiting Customers</button>
                  <button class="btn-blue-save custBtn" @click="clearCustomerInfo()">Create New Customer</button>                
                </div>
              </div>
            </div> -->
            <div v-if="isCustomerNotExist" class="customerModal" id="customerNotExist">
          <div class="customerModal-content">
            <div class="customerModal-body">
              <img src="../assets/user-slash.svg" alt="" class="logo" />
              <p class="customerModalText">
                Customer does not exist
              </p>
              <button type="button" @click="cancelCustomerReg()" class="btn okBtn">Proceed With Exisiting Customers</button>
              <button
                type="button"
                class="btn cancelBtn"
                @click="clearCustomerInfo()"
              >
                Create New Customer
              </button>
            </div>
          </div>
        </div>
            <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Vehicle Information</b></span></nav>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label for="currentMiles" class="col-form-label col-form-label-sm"> Vin Number </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="text" name="Vin Number" v-validate="'min:6'" class="form-control input-sm"
                  data-vv-as="Vin Number" v-model.trim="quote.vinNumber" placeholder="Enter Minimum Last 6 characters"
                  @input="getVinFraudReason()" :class="{'input-error': blackListedVin==true}">
                <div v-if="errors.has('Vin Number')" class="alert-danger">{{ errors.first('Vin Number') }}</div>
              </div>
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center"
                v-if="this.quote.vinNumber != '' && this.quote.vinFraudReason != null">
                <label for="currentMiles"> Vin Fraud Reason </label>
              </div>
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center"
                v-if="this.quote.vinNumber != '' && this.quote.vinFraudReason != null">
                <label for="currentMiles" class="col-form-label col-form-label-sm"> {{ quote.vinFraudReason }} </label>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label for="year" class="col-form-label col-form-label-sm"> Year </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <input type="text" name="year" v-validate="'digits:4'" data-vv-as="Year" class="form-control input-sm"
                  v-model.trim="quote.year" placeholder="Enter Year" maxlength="4"
                  onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                <div v-if="errors.has('year')" class="alert-danger">{{ errors.first('year') }}</div>
              </div>
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label for="make" class="col-form-label col-form-label-sm"> Make </label>
              </div>
              <div class="col-12 col-md-12   justify-content-lg-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <input type="text" name="make" v-validate="'max:150'" class="form-control input-sm" data-vv-as="Make"
                  v-model.trim="quote.make" placeholder="Enter Make">
                <div v-if="errors.has('make')" class="alert-danger">{{ errors.first('make') }}</div>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="model" class="col-form-label col-form-label-sm"> Model </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <input type="text" name="model" v-validate="'max:150'" data-vv-as="Model" class="form-control input-sm"
                  v-model.trim="quote.model" placeholder="Enter Model">
                <div v-if="errors.has('model')" class="alert-danger">{{ errors.first('model') }}</div>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label for="currentMiles" class="col-form-label col-form-label-sm"> Trim Style </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <input type="text" name="trimStyle" class="form-control input-sm" v-model.trim="quote.trim"
                  placeholder="Enter Trim Style">
              </div>
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center">
                <label for="currentMiles" class="col-form-label col-form-label-sm"> Current Miles </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                <input type="text" name="currentMiles" class="form-control input-sm" v-validate="'numeric'"
                  data-vv-as="Current Miles" v-model.trim="quote.currentMiles" placeholder="Enter Miles">
                <div v-if="errors.has('currentMiles')" class="alert-danger">{{ errors.first('currentMiles') }}</div>
              </div>

            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 align-items-center">
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center"
               v-if="blackListedVin==true">
                <label for="blackListReason" class="col-form-label col-form-label-sm"> Blacklist Reason </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 "
              v-if="blackListedVin==true">
                <textarea type="text" rows="3" cols="50" name="blackListReason" class="form-control"
                readonly v-model.trim="blackListReason"></textarea>
                <!-- <div v-if="errors.has('currentMiles')" class="alert-danger">{{ errors.first('currentMiles') }}</div> -->
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                v-if="(this.quote.customerFraudReason != 'Review' && this.quote.customerFraudReason != null && this.quote.dealerFraudReason == 'Review') || (this.quote.customerFraudReason == 'Review' && this.quote.dealerFraudReason != 'Review' && this.quote.dealerFraudReason != null) || (this.quote.customerFraudReason != 'Review' && this.quote.dealerFraudReason != 'Review') && (this.continue == 'Approval' || this.vincontinue == 'Approval' || this.dealerContinue == 'Approval') || this.blackListedVin==true">
                <label for="currentMiles" class="col-form-label col-form-label-sm required"> Fraud Managers Approval</label>
              </div>
              <div
                class="col-12 col-lg-4 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                v-if="(this.quote.customerFraudReason != 'Review' && this.quote.customerFraudReason != null && this.quote.dealerFraudReason == 'Review') || (this.quote.customerFraudReason == 'Review' && this.quote.dealerFraudReason != 'Review' && this.quote.dealerFraudReason != null) || (this.quote.customerFraudReason != 'Review' && this.quote.dealerFraudReason != 'Review') && (this.continue == 'Approval' || this.vincontinue == 'Approval' || this.dealerContinue == 'Approval') || this.blackListedVin==true">
                <input type="text" name="Approval Note" v-validate="'required'" class="form-control input-sm"
                  @input="enableSubmit()" data-vv-as="Approval Note"
                  placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman" v-model.trim="quote.approvalNote">
                <div v-if="errors.has('Approval Note')" class="alert-danger">{{ errors.first('Approval Note') }}</div>
              </div>

            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12   d-flex justify-content-lg-end align-items-center"
                v-if="(this.quote.customerFraudReason == 'Review' && (this.quote.dealerFraudReason == 'Review' || this.quote.dealerFraudReason == null)) && (this.continue == 'Approval' || this.vincontinue == 'Approval' || this.dealerContinue == 'Approval')">
                <label for="currentMiles" class="col-form-label col-form-label-sm"> Fraud Managers Approval</label>
              </div>
              <div
                class="col-12 col-lg-4 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                v-if="(this.quote.customerFraudReason == 'Review' && (this.quote.dealerFraudReason == 'Review' || this.quote.dealerFraudReason == null)) && (this.continue == 'Approval' || this.vincontinue == 'Approval' || this.dealerContinue == 'Approval')">
                <input type="text" name="Approval Note" class="form-control input-sm" @input="enableSubmit()"
                  data-vv-as="Approval Note" placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman"
                  v-model.trim="quote.approvalNote">
                <div v-if="errors.has('Approval Note')" class="alert-danger">{{ errors.first('Approval Note') }}</div>
              </div>

            </div>

            <center>
              <button id="submitbtn" class="btn btn-secondary mb-2 mr-3" @click="submitQuote" disabled="disabled"
                v-if="selectQuote == ''">Submit</button>

              <button type="submit" class="btn btn-secondary mb-2 mr-3" @click="submitQuote" v-else> Copy New Quote
              </button>
              <button type="submit" class="btn btn-secondary mb-2 mr-3" @click="reset()">Reset</button>

            </center>
            <br><br>

          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpcommon from '../js/http-common.js'
import httpamort from '../js/http-amortization.js'
import httpcustomer from '../js/http-customer.js'
import httpsource from '../js/http-managesource.js'
import httpemployee from '../js/http-employee.js'
import httpdeal from '../js/http-dealstracking.js'
import Multiselect from 'vue-multiselect'
import util from '../js/common-utils'
import moment from 'moment'
import $ from 'jquery'
export default {
  components: {
    MainMenu,
    Multiselect,
    TopHeader,
    BottomFooter
  },
  name: 'generateQuote',
  data () {
    return {
      uploadErrorMessage: '',
      statusOptions: [],
      preferredContactOptions: [],
      openCustomerSection: false,
      blackListReason: '',
      blackListedVin: false,
      blackListInfoMessage: '',
      vehicleInfoMessage: '',
      customerInfoMessage: '',
      isLoading: false,
      isCustomerNotExist: false,
      msgcolor: {
        color: 'black'
      },
      information: '',
      message: '',
      continue: null,
      vincontinue: null,
      dealerContinue: null,
      tabName: 'Tab1',
      uploadingMessage: '',
      quote: this.initializedata(),
      dealersList: [],
      agentList: [],
      creditAnalystList: [],
      selectedFile: null,
      sources: [
        { sourceName: 'Dealer' },
        { sourceName: 'InHouse' }
      ],
      selectQuote: '',
      daysBackSent: 'New Quote',
      fetchList: [],
      daysBack: [
        { days: 'New Quote' },
        { days: '10' },
        { days: '20' },
        { days: '30' },
        { days: '40' },
        { days: '50' },
        { days: '60' },
        { days: '70' },
        { days: '80' },
        { days: '90' },
        { days: '100' }
      ],
      quoteIdsList: [],
      quoteDataList: [],
      states: [],
      customersList: [],
      yesNoOptions: [

        { option: 'Yes' },
        { option: 'No' }
      ],
      leaseTypes: [
        { type: 'Sale' },
        { type: 'LeaseBack' },
        { type: 'Prime Lease' },
        { type: 'Finance' }
      ],
      heads: [
        { name: 'Year' },
        { name: 'Manheim Data' },
        { name: 'Black Book' },
        { name: 'Base Evaluation' },
        { name: 'Judgmental Adjustments' },
        { name: 'Final Evaluation' },
        { name: 'Evaluation Comments' }
      ],
      inhouseList: [
        { inhouseValue: 'Dupont Registry' },
        { inhouseValue: 'Sports Car Markett' },
        { inhouseValue: 'Google' },
        { inhouseValue: 'Instagram' },
        { inhouseValue: 'Facebook' },
        { inhouseValue: 'Existing Customer' },
        { inhouseValue: 'Other' }
      ],
      heads: [
        { name: 'Year' },
        { name: 'Manheim Data' },
        { name: 'Black Book' },
        { name: 'Base Evaluation' },
        { name: 'Judgmental Adjustments' },
        { name: 'Final Evaluation' },
        { name: 'Evaluation Comments' }
      ],
      types: [
        { id: 'P', name: 'Personal' },
        { id: 'B', name: 'Business' }
      ],
      userprefixs: [],
      fraudIndicatorList: [],
      requiredfieldcontent: '*',
      redFlagReasonList: [],
      fraudMobileError: '',
      customer: this.createEmptyCustomerObject(),

    }
  },
  watch: {
    'customer.customerType' : function (newVal) {
      if(newVal) {
        console.log(newVal,'newVal')
      }
    }
  },
  methods: {
    formatCellPhoneNumber: function (event) {
      this.getCustomerMobileFraud()
      var phone = this.customer.mobileNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.mobileNumber = phone
      if (this.customer.mobileNumber == '') {
        this.customer.fraudCell = 'N'
      }
    },
    formatWorkPhoneNumber: function (event) {
      var phone = this.customer.workNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.workNumber = phone
    },
    formatFaxNumber: function (event) {
      var phone = this.customer.faxNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.faxNumber = phone
    },
    formatFraudPhoneNumber: function (event) {
      var phone = this.customer.fraudCell
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.fraudCell = phone
    },
    changeFraudInd () {
      if (this.customer.fraudInd == 'Y' && this.customer.fraudCell == 'N') {
        this.customer.redFlagReason = ''
      }
    },
    eligibilityFlag () {
      if (this.customer.fraudInd === 'R') {
        this.customer.redFlagReason = 'Review'
      } else { this.customer.redFlagReason = '' }
    },
     createEmptyCustomerObject () {
      return {
        fraudInd: 'Y',
        selectedUserPrefixCode: '',
        firstName: '',
        middleName: '',
        lastName: '',
        businessName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        selectedStateCode: '',
        countryName: 'USA',
        zipCode: '',
        emailId: '',
        confirmEmailId: '',
        workNumber: '',
        mobileNumber: '',
        faxNumber: '',
        preferredContactCode: 'A',
        customerType: 'P',
        selectedStatusCode: 'A',
        redFlagReason: '',
        fraudCell: 'N'
      }
    },
    getCustomerMobileFraud () {
      httpcustomer
        .get(
          '/customer/checkfraudMobileNumber/' +
            this.customer.mobileNumber.replace(/[^0-9]/g, '')
        )
        .then(response => {
          if (response.data == 'Y') {
            this.fraudMobileError = 'The given MobileNumber is blocked'
          } else {
            this.fraudMobileError = ''
          }
        })
    },
    logType () {
      console.log(this.customer.customerType)
    },
    reset () {
      this.information = ''
      this.quote = this.initializedata()
      this.selectQuote = ''
      this.daysBackSent = 'New Quote'
      this.quoteIdsList = []
      this.$validator.reset()
      document.getElementById('submitbtn').disabled = true
    },
    onFileSelected (event) {
      const file = event.target.files[0];
      console.log(file,'file')
      const validExtensions = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel',                                         // .xls
        'application/vnd.ms-excel.sheet.macroEnabled.12'                    // .xlsm
      ];
      if (file && validExtensions.includes(file.type)) {
        this.selectedFile = file;
        this.uploadErrorMessage = '';
      } else {
        this.uploadErrorMessage = 'Please attach a valid file.';
        this.selectedFile = null;
      }
    },
    async onUpload () {
      console.log('testing')
      this.uploadingMessage = ''
      this.openCustomerSection = false
      this.customer = this.createEmptyCustomerObject()
      this.information = ''
      this.message = ''

      // Current Miles  - ??? May be ---- odometer
      // Lease Type  - Dropdown with values -- Sale, LeaseBack -- We are getting ---- Lease
      // Customer Exist Or Not Suggestion

      // this.quoteDataList = response.data
      //   this.quote.year = this.quoteDataList[0].lmYear
      //   this.quote.loanAmount = this.quoteDataList[0].lmLoanAmount
      //   this.quote.leaseType = this.quoteDataList[0].lmLeaseType
      //   this.quote.source = this.quoteDataList[0].lmSource
      //   this.quote.year = this.quoteDataList[0].lmYear  ----- Yes
      //   this.quote.make = this.quoteDataList[0].lmMake  ----- Yes
      //   this.quote.model = this.quoteDataList[0].lmModel ----- Yes
      //   this.quote.currentMiles = this.quoteDataList[0].lmMiles
      //   this.quote.vinNumber = this.quoteDataList[0].lmVin  ----- Yes
      //   this.quote.inHouseName = this.quoteDataList[0].inhouseCategory
      //   this.quote.terms = this.quoteDataList[0].lmRemainingPayments
      //   this.getDealerDetails(this.quoteDataList[0].dealerId)
      //   this.getAgentDetails(this.quoteDataList[0].employeeId)
      //   this.getCreditAnalystDetails(this.quoteDataList[0].creditAnalystId)
      //   this.getCustomerDetails(this.quoteDataList[0].customerId)

      // Check if a file is selected
      if (document.getElementById('uploadfile').value != '') {
        this.isLoading = true
        this.quote = this.initializedata()
        this.uploadErrorMessage = ''
        // var modal = document.getElementById('myModal')
        // modal.style.display = 'block'
        const fd = new FormData()
        fd.append('files', this.selectedFile, this.selectedFile.name)
        // await fetch('http://3.228.238.128:8002/extract_data', {
        // await fetch('https://uatapi.llpsales.com/extract_data', {
        const domainUrl = window.location.hostname
        console.log(domainUrl,'domainURL')
        const pythonApi = domainUrl === 'localhost' || domainUrl === 'staging.llpsales.com' ? 'https://stagingapi.llpsales.com/extract_data' : 'https://uatapi.llpsales.com/extract_data';
        await fetch(pythonApi, {
          method: 'POST',
          body: fd
        }).then(response => {
          this.isLoading = false
            // console.log("sleep over")
            if (!response.ok) {
                throw new Error('Network response was not ok');
                }
                return response.json();
                }).then(data => {
                  if (data[0].status == 200) {
                    this.extractData(data[0])
                  } else {
                    this.uploadErrorMessage = 'Please attach a valid quote'
                  }
                  
                  
      //             this.quote.vinNumber = data[0].vehicle["vin#"]

      //              const customer = this.customersList.find(
      //   (cust) => `${cust.firstName} ${cust.lastName}` === data[0].applicant.firstName
      // );
      
      // if (customer) {
      //   this.quote.selectedCustomerId = customer;
      // } else {
      //   // Handle the case where the customer is not found
      //   console.error('Customer not found in the customers list');
      // }
                  
                  console.log('Data received:', data);
            //       this.filteredCustomersList = this.customersList.flat().filter(
            //     (customer) => customer.firstName === data[0].applicant.firstName
            // );      

      // Optionally, you can automatically select the first matching customer
      // if (this.filteredCustomersList.length > 0) {
        // this.quote.selectedCustomerId = this.filteredCustomersList[0].customerId;
      //   console.log('this.filteredCustomersList:', this.filteredCustomersList);
      // } else {
      //   this.quote.selectedCustomerId = null; // Clear the selection if no match is found
      // }
                  })
          .catch(error => {
            this.isLoading = false
            this.selectedFile = null
            console.error('There was a problem with the fetch operation:', error);
          });
      }
    },
    getVehicleInfo (vin) {
      httpdeal.get('/quote/getVechicleInfo/' + vin).then(response => {
        if (response.data[0].year == null && response.data[0].make == null && response.data[0].model == null && response.data[0].trim == null) {
          httpdeal.get('/quote/getVechicleInfoMessage').then(response => {
            this.vehicleInfoMessage = response.data
          })
          var modal = document.getElementById('vinDecoder')
          modal.style.display = 'block'
          this.quote.year = ''
          this.quote.make = ''
          this.quote.model = ''
          this.quote.trim = ''
        } else {
          this.quote.year = response.data[0].year
          this.quote.make = response.data[0].make
          this.quote.model = response.data[0].model
          this.quote.trim = response.data[0].trim
          this.getVinBlackListInfo(vin)
        }
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    getQuoteIds () {
      if (this.daysBackSent != 'New Quote') {
        httpdeal.get('/quote/getQuoteIds/' + this.daysBackSent).then(response => {
          this.quoteIdsList = response.data
          // for (var ii=1; ii < 210; ii++)
          // {
          // if (ii%10 == 0) console.log("numbers  : "+ii);
          // }
          // for(let b = 0; b < 100; b++){
          //  if (b%10 == 0){
          //    this.$set(this.fetchList, b, {
          //   id: b
          // })
          // }
          //   }
          // console.log("numbers  : "+JSON.stringify(this.fetchList))
        })
          .catch(e => {
            console.log(e)
            this.errors.push(e)
          })
      } else if (this.daysBackSent == 'New Quote') {
        this.quoteIdsList = []
        this.reset()
      }
    },

    getQuoteByQuoteId () {
      this.information = ''
      httpdeal.get('/quote/getQuoteByQuoteId/' + this.selectQuote.quoteId).then(response => {
        this.quoteDataList = response.data
        this.quote.year = this.quoteDataList[0].lmYear
        this.quote.loanAmount = this.quoteDataList[0].lmLoanAmount
        this.quote.leaseType = this.quoteDataList[0].lmLeaseType
        this.quote.source = this.quoteDataList[0].lmSource
        this.quote.year = this.quoteDataList[0].lmYear
        this.quote.make = this.quoteDataList[0].lmMake
        this.quote.model = this.quoteDataList[0].lmModel
        this.quote.currentMiles = this.quoteDataList[0].lmMiles
        this.quote.vinNumber = this.quoteDataList[0].lmVin
        this.quote.inHouseName = this.quoteDataList[0].inhouseCategory
        this.quote.terms = this.quoteDataList[0].lmRemainingPayments
        this.getDealerDetails(this.quoteDataList[0].dealerId)
        this.getAgentDetails(this.quoteDataList[0].employeeId)
        this.getCreditAnalystDetails(this.quoteDataList[0].creditAnalystId)
        this.getCustomerDetails(this.quoteDataList[0].customerId)
        // console.log("HELLO DT : " + JSON.stringify(this.quoteDataList))
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    getCustomerDetails (customerId) {
      if (customerId >= 0) {
        httpcustomer.get('/customer/' + customerId).then(response => {
          var customerlist = response.data
          this.quote.selectedCustomerId = customerlist[0]
          // this.getFraudCustomer(customerId)
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getAgentDetails (employeeId) {
      if (employeeId >= 0) {
        httpemployee.get('/employee/' + employeeId).then(response => {
          var employeelist = response.data
          this.quote.selectedEmployeeId = employeelist[0]
          // console.log("ID : " + JSON.stringify(this.selectedEmployeeData))
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getCreditAnalystDetails (employeeId) {
      if (employeeId >= 0) {
        httpemployee.get('/employee/' + employeeId).then(response => {
          var employeelist = response.data
          this.quote.selectedCreditAnalystId = employeelist[0]
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },

    getDealerDetails (dealerId) {
      if (dealerId >= 0) {
        httpsource.get('/dealerbyid/' + dealerId).then(response => {
          var dealerlist = response.data
          this.quote.selectedDealerId = dealerlist
          // console.log("ID : " + JSON.stringify(this.quote.selectedDealerId))
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    createSearchObject () {
      return {
        'firstName': '',
        'lastName': '',
        'roleType': '',
        'statusCode': 'A'
      }
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#deals').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    updateDealer () {
      this.dealersList = []
      this.quote.dealerFraudReason = null
      if (this.quote.source == 'InHouse') {
        httpsource.get('/dealersearch').then(response => {
          if (response.data.length != 0) {
            this.dealersList = []
            this.dealersList = response.data
          }
        })
          .catch(error => {
            console.log('Failed to load dealers:' + error)
          })
      } else if (this.quote.selectedEmployeeId.employeeId != '') {
        httpemployee.get('/employee/' + parseInt(this.quote.selectedEmployeeId.employeeId)).then(response => {
          this.dealersList = []
          this.quote.selectedDealerId = ''
          for (var i = 0; i < response.data.length; i++) {
            var employeeobject = response.data[i]
            for (var i = 0; i < employeeobject.empBusinessCoverageAreas.length; i++) {
              var empbuscovarea = employeeobject.empBusinessCoverageAreas[i]
              this.dealersList.push({
                'dealerId': empbuscovarea.id.dealerId,
                'dealerName': empbuscovarea.ddealerInfo.dealerName
              })
            }
          }
        }).catch(e => { console.log(e) })
      }
    },

    displayFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    displayAgentFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },
    displayDealerFullName (option) {
      return `${option.dealerName}`
    },

    getFraudCustomer (customerId) {
      if (this.quote.vinFraudReason == null && this.LesseeFraudReason == null) {
        this.quote.overrideFraud = null
        this.continue = null
        this.vincontinue = null
      }
      httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + parseInt(customerId)).then(response => {
        if (response.data.length !== 0 && response.data[0].customerFraudReason !== '' && response.data[0].customerFraudReason !== undefined && response.data[0].customerFraudReason !== null) {
          this.quote.customerFraudReason = response.data[0].customerFraudReason
          this.continue = null
          if (this.quote.vinFraudReason == null) {
            this.quote.approvalNote = null
            this.vincontinue = null
          }
          if (this.quote.customerFraudReason != null) {
            if (this.quote.customerFraudReason != 'Review') {
              var modal = document.getElementById('myModal')
              modal.style.display = 'block'
            } else {
              modal = document.getElementById('reviewAlert')
              modal.style.display = 'block'
            }
          }
          // }
        } else {
          this.quote.customerFraudReason = null
          this.continue = null
          if (this.quote.vinFraudReason == null && this.quote.customerFraudReason == null) {
            this.quote.approvalNote = null
            this.vincontinue = null
          }
          document.getElementById('submitbtn').disabled = false
        }
      })
      // this.retrieveCustomerList()
    },

    getFraudDealer (dealerId) {
      if (dealerId >= 0) {
        httpsource.get('/dealerbyid/' + dealerId).then(response => {
          console.log('Dealer Info')
          if (response.data.fraudInd === 'Y') {
            console.log(response.data.redFlagReason)
            this.quote.dealerFraudReason = response.data.redFlagReason == '' ? 'NA' : response.data.redFlagReason
            if (this.quote.dealerFraudReason !== 'Review') {
              var modal = document.getElementById('myModal')
              modal.style.display = 'block'
            } else {
              modal = document.getElementById('reviewAlert')
              modal.style.display = 'block'
            }
          } else {
            this.quote.dealerFraudReason = null
          }
        })
          .catch(e => {
            this.errors.push(e)
          })
      } else {
        this.quote.dealerFraudReason = null
      }
    },

    clearVIN () {
      var modal = document.getElementById('vinDecoder')
      modal.style.display = 'none'
      this.vehicleInfoMessage = ''
    },
    clearDialog () {
      var modal = document.getElementById('vinBlacklist')
      modal.style.display = 'none'
    },
    clearCustomerInfo () {
      // var modal = document.getElementById('customerNotExist')
      // modal.style.display = 'none'
      this.isCustomerNotExist = false
      this.openCustomerSection = true
      this.customer.firstName = this.unregisterData.applicant.firstName
      this.customer.middleName = this.unregisterData.applicant.middleInitial
      this.customer.lastName = this.unregisterData.applicant.lastName
      this.customer.zipCode = this.unregisterData.applicant.zipCode
      this.customer.emailId = this.unregisterData.applicant.email
      this.customer.countryName = 'USA'
      this.customer.mobileNumber = this.unregisterData.applicant.primaryPhone.toString().replace(/[^0-9]/g, '')
      this.customer.addressLine1 = this.unregisterData.applicant.streetAddress
this.zipDecoder();
    },
    cancelCustomerReg () {
      // var modal = document.getElementById('customerNotExist')
      // modal.style.display = 'none'
      this.isCustomerNotExist = false
    },
    fraudoverride () {
      if (this.quote.customerFraudReason != null) {
        if (this.quote.customerFraudReason != 'Review') {
          this.continue = 'Approval'
          var modal = document.getElementById('myModal')
          modal.style.display = 'none'
        } else {
          this.continue = 'Approval'
          modal = document.getElementById('reviewAlert')
          modal.style.display = 'none'
          document.getElementById('submitbtn').disabled = false
        }
      } if (this.quote.dealerFraudReason != null) {
        if (this.quote.dealerFraudReason !== 'Review') {
          this.dealerContinue = 'Approval'
          modal = document.getElementById('myModal')
          modal.style.display = 'none'
        } else {
          this.dealerContinue = 'Approval'
          modal = document.getElementById('reviewAlert')
          modal.style.display = 'none'
          document.getElementById('submitbtn').disabled = false
        }
      } if (this.quote.vinFraudReason != null) {
        this.vincontinue = 'Approval'
        modal = document.getElementById('myModal')
        modal.style.display = 'none'
      }
    },
    fraudoverridecancel () {
      if (this.quote.customerFraudReason != null) {
        if (this.quote.customerFraudReason != 'Review') {
          this.continue = 'Approval'
          var modal = document.getElementById('myModal')
          modal.style.display = 'none'
        } else {
          this.continue = 'Approval'
          var modal = document.getElementById('reviewAlert')
          modal.style.display = 'none'
        }
      } else if (this.quote.vinFraudReason != null) {
        this.vincontinue = null
        var modal = document.getElementById('myModal')
        modal.style.display = 'none'
      }
    },
    // save
    changeLesseeName (event) {
      this.quote.lesseeName = event.target.options[event.target.options.selectedIndex].text
      this.getCustomerDetails()
    },
    submitQuote () {
      // Integrate the New Quote service
      // const fieldsToValidate = ['proposedLessee','salesperson' ,'source','loanAmount','terms','Vin Number','year' , 'make', 'model', 'currentMiles', 'Approval Note']
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.isLoading = true
          if (!this.openCustomerSection) {
          let newquote = {
            'creationUserI': this.$session.get('user_id'),
            'lastUpdatedUserI': this.$session.get('user_id'),
            'lmQuote': util.formatDateJS(this.quote.quoteDate),
            'lmRemainingPayments': this.quote.terms,
            'lmQuoteStatus': 'Open',
            'lmLoanAmount': this.quote.loanAmount,
            'lmLeaseType': this.quote.leaseType,
            'lmSource': this.quote.source,
            'lmYear': this.quote.year,
            'lmMake': this.quote.make,
            'lmModel': this.quote.model,
            'lmMiles': this.quote.currentMiles,
            'lmVin': this.quote.vinNumber,
            'lmTrim': this.quote.trim,
            'overrideFraud': this.quote.approvalNote,
            'inhouseCategory': this.quote.inHouseName,
            'customerId': this.quote.selectedCustomerId.customerId,
            'employeeId': this.quote.selectedEmployeeId.employeeId,
            'creditAnalystId': this.quote.selectedCreditAnalystId.employeeId != undefined ? this.quote.selectedCreditAnalystId.employeeId : 0,
            'dealerId': this.quote.selectedDealerId.dealerId

          }
          console.log('newquote')
          console.log(newquote)
          httpdeal.post('/quote', newquote).then(response => {
            var status = response.data
            this.isLoading = false
            console.log('quote status')
            console.log(status)
            // if (status.length != 0) {
            this.information = 'Quote Successfully added into the system with quote number : ' + response.data.lmQuoteId
            this.msgcolor.color = 'Blue'
            this.quote = this.initializedata()
            this.daysBackSent = 'New Quote'
            // this.getQuoteIds()
            this.selectQuote = ''
            this.continue = null
            this.vincontinue = null
            this.dealerContinue = null
            this.selectedFile = null
            // this.$refs.fileInput.value = '';
            // } else {
            //   this.msgcolor.color = 'Red'
            //   this.information = ''
            // }
          })
            .catch(e => {
              this.isLoading = false
              this.msgcolor.color = 'Red'
              console.log(e,'eeeee')
              console.log(e.name,'eeeee')
              console.log(e.message,'eeeee')
              this.information = '' || e.name || e.message
            })
        } else {
          this.createCustomer()
        }
        }
      })
    },

    displayMonth (row) {
      try {
        if ((Math.floor((this.quote.terms - 2) / (row * 12)) > 0)) { return row * 12 } else { return this.quote.terms - 2 }
      } catch (e) {
        return 1
      }
    },

    fetchData () {
      this.retrieveCustomerList()
      this.retrieveAgentList()
      this.getQuoteIds()
    },

    retrieveAgentList () {
      let searchEmployee = this.createSearchObject()
      httpemployee.post('/employee/search/', searchEmployee).then(response => {
        if (response.data.length > 0) {
          console.log(response.data,'response.data')
          this.agentList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'SR');
          })
          console.log(this.agentList,'this.agentList')
          this.creditAnalystList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'CA');
          })
          var customerlist = response.data
          var customerobject = customerlist[0]
          if (customerobject.employeeId == this.selectedEmployeeId) {
            this.quote.selectedEmployeeId = customerobject.firstName + ',' + customerobject.middleName + ' ' + customerobject.lastName
          }
        }
      })
        .catch(e => {
          this.errorslist.push(e)
        })
    },
    retrieveCustomerList () {
      httpcustomer.get('/customer/').then(response => {
        this.customersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },

    getVinFraudReason () {
      this.blackListedVin = false
      if (this.quote.vinNumber.length >= 6) {
        this.getVehicleInfo(this.quote.vinNumber)
        httpcustomer.get('customer/getVinFraudDetails?vin=' + this.quote.vinNumber).then(response => {
          if (response.data.length != 0) {
            if (response.data[0].vinFraudReason != null && response.data[0].vinFraudReason.length != 0) {
              this.quote.vinFraudReason = response.data[0].vinFraudReason
              if (this.quote.customerFraudReason == null) {
                this.quote.approvalNote = null
              }
              if (this.quote.approvalNote != null) {
                document.getElementById('submitbtn').disabled = false
              } else {
                document.getElementById('submitbtn').disabled = true
              }

              if (this.quote.vinFraudReason != null && this.quote.approvalNote == null) {
                var modal = document.getElementById('myModal')
                modal.style.display = 'block'
                this.vincontinue = 'Approval'
              }
            }
          } else {
            this.quote.vinFraudReason = null
            this.vincontinue = null
            if (this.quote.vinFraudReason == null && this.quote.customerFraudReason) {
              this.quote.approvalNote = null
            }
            document.getElementById('submitbtn').disabled = false
          }
        })
          .catch(e => {
            console.log(e)
            this.errors.push(e)
          })
      } else {
        this.quote.vinFraudReason = null
        this.vincontinue = null
        if (this.quote.vinFraudReason == null && this.quote.customerFraudReason) {
          this.quote.approvalNote = null
        }
        document.getElementById('submitbtn').disabled = false
      }
    },
     getVinBlackListInfo (vin) {
     return httpcommon.get(
          "vinblacklist/filterVinList?type=blacklisted&vinNumber=" +vin.toUpperCase()
        ).then(response=>{
          if(response.data.content.length){
            this.blackListInfoMessage = 'This VIN has been blacklisted'
          this.blackListedVin = response.data.content[0].blacklisted
          this.blackListReason = response.data.content[0].blacklistReason
          var modal = document.getElementById('vinBlacklist')
          modal.style.display = 'block'
          } else {
            this.blackListedVin = false
          }
        })
    },

    enableSubmit () {
      document.getElementById('submitbtn').disabled = false
    },

    retrieveDealerList () {
      httpsource.get('/dealer/').then(response => {
        this.dealersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    extractData (data) {
      this.quote.vinNumber = data.vehicle["vin#"]
      this.quote.source = data.internalDetails.dealSource
      this.quote.loanAmount = data.loan.loanAmount
      this.quote.terms = data.loan.terms
      this.quote.currentMiles = data.vehicle.miles
      // this.quote.quoteDate = data.applicationDetails.applicationDate
      this.getVinFraudReason()

      const customer = this.customersList.find(
        (cust) => cust.firstName.toUpperCase() === data.applicant.firstName.toUpperCase() && cust.middleName.toUpperCase() == data.applicant.middleInitial.toUpperCase() && cust.lastName.toUpperCase() == data.applicant.lastName.toUpperCase()
      
      );
      
      if (customer) {
        console.log(customer)
        this.quote.selectedCustomerId = customer;
        this.getFraudCustomer(this.quote.selectedCustomerId.customerId)
      } else {
        // Handle the case where the customer is not found
      // var modal = document.getElementById('customerNotExist')
      // modal.style.display = 'block'
      this.isCustomerNotExist = true
      this.customerInfoMessage = 'Do you want to create new customer or want to proceed with exisiting customers ?'
      this.unregisterData = data
// this.zipDecoder(data)
// this.createCustomer (data)
      }
    },
    saveCustomerData () {
       const fieldsToValidate = ['First Name', 'Last Name', 'Business Name' ,'Zip Code' , 'Email' , 'Cell Phone' , 'Fraud Cell Phone' , 'Work Phone' , 'Red Flag Reason' , 'Fax'];
      this.$validator.validateAll(fieldsToValidate).then(() => {
        if (!this.errors.any()) {
          this.createCustomer()
          this.fraudMobileError = ''
        }
      })
    },
    createCustomer () {
      var date = new Date()
      var currentDate =
        date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
      let newCustomer = {
        firstName: this.customer.firstName,
        middleName: this.customer.middleName,
        lastName: this.customer.lastName,
        businessName: this.customer.businessName,
        customerType: this.customer.customerType,
        dealerId: null,
        fraudInd: this.customer.fraudInd,
        redFlagReason: this.customer.redFlagReason,
        userPrefixC:
          this.customer.selectedUserPrefixCode.length == 0
            ? null
            : this.customer.selectedUserPrefixCode,
        address: {
          street1: this.customer.addressLine1,
          street2: this.customer.addressLine2,
          city: this.customer.city,
          zipCode: this.customer.zipCode,
          stateFipsC:
            this.customer.selectedStateCode.length == 0
              ? null
              : this.customer.selectedStateCode.stateFipsC,
          country: this.customer.countryName,
          addressType: null,
          inactiveD: this.customer.selectedStatusCode == 'A' ? null : date,
          creationD: date,
          creationUserI: this.$session.get('user_id'),
          lastUpdatedD: null,
          lastUpdatedUserI: null
        },
        digitalContactInfo: {
          email: this.customer.emailId,
          faxNumber: this.customer.faxNumber.replace(/[^0-9]/g, ''),
          mobileNumber: this.customer.mobileNumber.replace(/[^0-9]/g, ''),
          preferredContact: this.customer.preferredContactCode,
          workNumber: this.customer.workNumber.replace(/[^0-9]/g, ''),
          fraudMobileNumber: this.customer.fraudCell
        },
        inactiveD: this.customer.selectedStatusCode == 'A' ? null : date,
        creationD: date,
        creationUserI: this.$session.get('user_id'),
        lastUpdatedD: null,
        lastUpdatedUserI: null
      }
      // console.log(newCustomer)
      if (this.fraudMobileError == '') {
        httpcustomer
          .post('/customer/', newCustomer)
          .then(response => {
            var status = response.data
            if (status == 'CREATED') {
              // this.message = 'Customer Successfully added into the system'
              this.msgcolor.color = 'Blue'
              // this.customer = this.createEmptyCustomerObject()
              // httpcustomer.get('/customer/').then(response => {
              httpcustomer.get(`/customer/search?firstName=${this.unregisterData.applicant.firstName}&lastName=${this.unregisterData.applicant.lastName}&page=1&size=5`).then(response => {
        // this.customersList = response.data
        const customer = response.data.content.find(
        (cust) => cust.firstName.toUpperCase() === this.unregisterData.applicant.firstName.toUpperCase() && cust.lastName.toUpperCase() == this.unregisterData.applicant.lastName.toUpperCase()
      
      );
      
      if (customer) {
        console.log(customer)
        // this.isLoading = false
        this.quote.selectedCustomerId = customer;
        // this.getFraudCustomer(this.quote.selectedCustomerId.customerId)
        let newquote = {
            'creationUserI': this.$session.get('user_id'),
            'lastUpdatedUserI': this.$session.get('user_id'),
            'lmQuote': util.formatDateJS(this.quote.quoteDate),
            'lmRemainingPayments': this.quote.terms,
            'lmQuoteStatus': 'Open',
            'lmLoanAmount': this.quote.loanAmount,
            'lmLeaseType': this.quote.leaseType,
            'lmSource': this.quote.source,
            'lmYear': this.quote.year,
            'lmMake': this.quote.make,
            'lmModel': this.quote.model,
            'lmMiles': this.quote.currentMiles,
            'lmVin': this.quote.vinNumber,
            'lmTrim': this.quote.trim,
            'overrideFraud': this.quote.approvalNote,
            'inhouseCategory': this.quote.inHouseName,
            'customerId': this.quote.selectedCustomerId.customerId,
            'employeeId': this.quote.selectedEmployeeId.employeeId,
            'creditAnalystId': this.quote.selectedCreditAnalystId.employeeId != undefined ? this.quote.selectedCreditAnalystId.employeeId : 0,
            'dealerId': this.quote.selectedDealerId.dealerId

          }

          httpdeal.post('/quote', newquote).then(response => {
            var status = response.data
            this.isLoading = false
            console.log('quote status')
            console.log(status)
            // if (status.length != 0) {
            this.information = 'Quote Successfully added into the system with quote number : ' + response.data.lmQuoteId
            this.msgcolor.color = 'Blue'
            this.quote = this.initializedata()
            this.daysBackSent = 'New Quote'
            // this.getQuoteIds()
            this.selectQuote = ''
            this.continue = null
            this.vincontinue = null
            this.dealerContinue = null
            this.selectedFile = null
            // this.$refs.fileInput.value = '';
            this.customer = this.createEmptyCustomerObject()
            this.selectedFile = null
            this.openCustomerSection = false
            this.retrieveCustomerList()
            // } else {
            //   this.msgcolor.color = 'Red'
            //   this.information = ''
            // }
          })
            .catch(e => {
              this.isLoading = false
              this.errors.push(e)
              this.msgcolor.color = 'Red'
              this.information = '' || e.name || e.message
            })
      }
      })
        .catch(e => {
          this.isLoading = false
          console.log(e)
          this.errors.push(e)
          this.msgcolor.color = 'Red'
          this.message = '' || e.name || e.message
        })
            } else {
              this.msgcolor.color = 'Red'
              this.message = ''
            }
          })
          .catch(e => {
            th.isLoading = false
            this.errors.push(e)
            this.msgcolor.color = 'Red'
            this.message = '' || e.name || e.message
          })
      }
    },
  //   async createCustomer (data) {
  //     this.isLoading = true
  //     var date = new Date()
  //     var currentDate =
  //       date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
  //       const { city, stateCode } = await this.zipDecoder(data.applicant.zipCode);
  //     let newCustomer = {
  //       firstName: data.applicant.firstName,
  //       middleName: data.applicant.middleInitial,
  //       lastName: data.applicant.lastName,
  //       businessName: '',
  //       // customerType: this.customer.customerType,
  //       customerType: 'P',
  //       dealerId: null,
  //       fraudInd: 'Y',
  //       redFlagReason: '',
  //       userPrefixC: "Mr",
  //       address: {
  //         street1: data.applicant.streetAddress,
  //         street2: '',
  //         city: city,
  //         zipCode: data.applicant.zipCode,
  //         stateFipsC: stateCode,
  //         country: 'USA',
  //         addressType: null,
  //         inactiveD: null,
  //         creationD: date,
  //         creationUserI: this.$session.get('user_id'),
  //         lastUpdatedD: null,
  //         lastUpdatedUserI: null
  //       },
  //       digitalContactInfo: {
  //         email: data.applicant.email,
  //         faxNumber: '',
  //         mobileNumber: data.applicant.primaryPhone.toString(),
  //         preferredContact: 'A',
  //         workNumber: '',
  //         fraudMobileNumber: 'N'
  //       },
  //       inactiveD: null,
  //       creationD: date,
  //       creationUserI: this.$session.get('user_id'),
  //       lastUpdatedD: null,
  //       lastUpdatedUserI: null
  //     }
  //     // console.log(newCustomer)
      
  //      await httpcustomer
  //         .post('/customer/', newCustomer)
  //         .then(response => {
  //           var status = response.data
  //           if (status == 'CREATED') {
  //             httpcustomer.get('/customer/').then(response => {
  //       this.customersList = response.data
  //       const customer = this.customersList.find(
  //       (cust) => cust.firstName.toUpperCase() === data.applicant.firstName.toUpperCase() && cust.lastName.toUpperCase() == data.applicant.lastName.toUpperCase()
      
  //     );
      
  //     if (customer) {
  //       console.log(customer)
  //       this.isLoading = false
  //       this.quote.selectedCustomerId = customer;
  //       this.getFraudCustomer(this.quote.selectedCustomerId.customerId)
  //     }
  //     })
  //       .catch(e => {
  //         this.isLoading = false
  //         console.log(e)
  //         this.errors.push(e)
  //       })
  //           } else {
              
  //           }
  //         })
  //         .catch(e => {
  //           this.isLoading = false
  //           console.log(e)
  //         })
      
  //   },
  //   async zipDecoder (zipCode) {
  //     if (zipCode.length == 5) {
  //       try {
  //      const response = await httpcommon.get('/statefip/zipCode/' + zipCode)
  //      const city = response.data.city || '';
  //      let state = response.data.state || '';
       
  //      if (city != null) {
        
  //       // Call another API to get state code by city
  //       const stateResponse = await httpcommon.get('/statefip/');
  //       for (let i = 0; i < stateResponse.data.length; i++) {
  //       if (stateResponse.data[i].stateAlphaC == state) {
  //         var stateCode = stateResponse.data[i].stateFipsC
  //         break;
  //       }
  //     }
  //     }
  //     return { city, stateCode};
  //       } catch (error) {
  //         this.isLoading = false
  //     this.errorslist.push(error);
  //     return { city: '', stateCode: null }; // Return empty values on error
  //   }
  // }
  // return { city: '', stateCode: null };
  //     },
 zipDecoder () {
  console.log('zip')
      if (this.customer.zipCode.length == 5) {
        console.log('length')
        httpcommon.get('/statefip/zipCode/' + this.customer.zipCode)
          .then(response => {
            if (response.data.city != null) {
              this.customer.city = response.data.city
            } else {
              this.customer.city = ''
            }
            if (response.data.city != null) {
              this.getCustomerStateDetails(response.data.state)
            } else {
              this.customer.selectedStateCode = ''
            }
          })

          .catch(e => { this.errorslist.push(e) })
      }
    },
    getCustomerStateDetails (stateFipsC) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateAlphaC == stateFipsC) {
          this.customer.selectedStateCode = this.states[i]
        }
      }
    },
    initializedata () {
      return {
        source: '',
        leaseType: '',
        dealerName: '',
        dealerFraudReason: null,
        inHouseName: '',
        quoteDate: new Date(),
        proposedLessee: '',
        customerFraudReason: null,
        approvalNote: '',
        vinFraudReason: null,
        terms: '',
        salesAgent: '',
        make: '',
        model: '',
        year: '',
        trim: '',
        currentMiles: '',
        vinNumber: '',
        selectedCustomerId: '',
        selectedEmployeeId: '',
        selectedCreditAnalystId: '',
        selectedDealerId: '',
        initialEquityTarget: '',
        exitEquityTarget: '',
        initialWholeSaleValue: '',
        exitWholeSaleValue: '',
        advancePayments: '',
        remainingPayments: '',
        loanFundingCost: '',
        leaseFundingCost: '',
        state: '',
        stateTaxRate: '',
        countyTaxRate: '',
        zipTaxRate: '',
        netPayDealer: '',
        payDealerDMVFees: '',
        TXTaxpaidByDealer: '',
        isTradeTaxExcempt: '',
        firstACHDate: '',
        lastACHDate: '',
        vehiclePrice: '',
        dealerTxnFee: '',
        totalPrice: '',
        cashCapReduction: '',
        tradeValue: '',
        tradePayoff: '',
        tradeCredit: '',
        totalCapReduction: '',
        leaseCapCost: '',
        llpInitialResidual: '',
        llpResidualAdjustment: '',
        llpFinalResidual: '',
        residualRevenue: '',
        leaseResidual: '',
        initialPreTaxLeasePayment: '',
        adjToMonthlyLeasePayment: '',
        finalPreTaxMonthlyLeasePayment: '',
        taxOnMonthlyTaxLeasePayment: '',
        finalMonthlyLeasePayment: '',
        upfrontLeasePaymentDue: '',
        totalCapCostReduction: '',
        taxDueAtInception: '',
        acquisitionFee: '',
        serviceContractFee: '',
        taxOnFees: '',
        dealerFee: '',
        estDMVFee: '',
        securityDeposit: '',
        other: '',
        totalDueUponSigning: '',
        lessTradeCredit: '',
        lessDealerDeposit: '',
        cashDueUponSigning: '',
        sumOfLeasePayments: '',
        depreciation: '',
        sumOfPreTaxLeasePayments: '',
        totalRentalCharge: '',
        taxOnInitialLeasePayments: '',
        monthlyDepreciation: '',

        loanAmount: '',
        loanPaymentEst: '',
        originationRevenue: '',
        originationReserve: '',
        originationIncome: '',
        annuityRevenueMonthly: '',
        annuityReserveMonthly: '',
        annuityIncomeMonthly: '',
        annuityRevenueLifeOfLease: '',
        annuityReserveLifeOfLease: '',
        annuityIncomeLifeOfLease: '',
        totalRevenueLifeOfLease: '',
        totalReserveLifeOfLease: '',
        totalIncomeLifeOfLease: '',
        taxDueOnCashCapRed: '',
        taxDueOnPmtsCapCost: '',
        taxOnTrade: '',

        paymentsData: [
          {
            amortest: 90,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 100,
            valuationcommentary: ''
          },
          {
            amortest: 19,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 23,
            valuationcommentary: ''
          },
          {
            amortest: 200,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 222,
            valuationcommentary: ''
          },
          {
            amortest: 990,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 999,
            valuationcommentary: ''
          },
          {
            amortest: 179,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 333,
            valuationcommentary: ''
          },
          {
            amortest: 99,
            manhemdatammr: '',
            manhemdatacomp1: '',
            manhemdatacomp2: '',
            manhemdatacomp3: '',
            manhemdatacomp4: '',
            manhemdatacomp5: '',
            manhemdatacomp6: '',
            bbexcellent: '',
            bbgood: '',
            bbfair: '',
            baseevaluation: '',
            jdgAdjEquipment: '',
            jdgAdjMarket: '',
            jdgAdjOther: '',
            finalEvaluation: 100,
            valuationcommentary: ''
          }

        ],
        totalValue: '',
        totalamortest: '',
        totalequity: '',
        totalpercentEquity: '',
        cashDueAtSigning: '',
        fullAmortizationList: ''
      }
    }

  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
    httpcommon
      .get('/staticdata/status/')
      .then(response => {
        this.statusOptions = response.data
      })
      .catch(e => {
        this.errorslist.push(e)
      })
    httpcommon
      .get('/staticdata/preferredcontact/')
      .then(response => {
        this.preferredContactOptions = response.data
      })
      .catch(e => {
        this.errors.push(e)
      }),
    httpcommon
      .get('/statefip/')
      .then(response => {
        this.states = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
      httpcommon
      .get('/userprefix/')
      .then(response => {
        this.userprefixs = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
      httpcommon
      .get('/keyvalues/getkeyvalues/' + 1)
      .then(response => {
        this.fraudIndicatorList = response.data
      })
      .catch(e => {
        this.errorslist.push(e)
      })
    httpcommon
      .get('/keyvalues/getkeyvalues/' + 23)
      .then(response => {
        this.redFlagReasonList = response.data
      })
      .catch(e => {
        this.errorslist.push(e)
      })
  },
  filters: {
    formatCustType (customerType) {
      if (customerType == '') {
        return 'Personal/Business'
      } else if (customerType == 'B') {
        return 'Business'
      } else if (customerType == 'P') {
        return 'Personal'
      }
    }
  },
  computed: {
    sortedDealers: function () {
      return this.dealersList.sort((a, b) => { return a.dealerName > b.dealerName ? 1 : -1 })
    },
    customerType: function () {
      var custSelect = this.quote.selectedCustomerId.customerId
      var custType = ''
      if (this.quote.selectedCustomerId.customerId != '') {
        this.customersList.forEach(customerObj => {
          if (customerObj.customerId == custSelect) {
            custType = customerObj.customerType
          }
        })
      }
      return custType
    },

    paymentRows () {
      if (isNaN(this.quote.terms) > 0) {
        return 1
      }
      if (Number(this.quote.terms) > 60) {
        return 1
      }
      return Math.ceil(this.quote.terms / 12) + 1
    }

  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>
<style scoped>
.input-sm {
  height: 40px;
}

.nextButton {
  margin: 0px;
  padding: 0px;
  border-radius: 6px;
  font-size: 10px;
  height: 30px;
  width: 100px;
}
.dialogContent {
  padding: 20px !important;
}
/* .createCustModal {
  justify-content: center !important;
  padding-top: 20px !important;

} */
/* .custBtn {
  margin: 0px;
  padding: 0px;
  border-radius: 6px;
  font-size: 12px;
  height: 50px;
  width: 40%;
} */
 .customerModal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.customerModal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 60vh !important;
  height: auto !important;
  max-height: 50vh;
  border-radius: 16px;
  text-align: center;
}
.customerModal-body {
  height: 100% !important;
}
.customerModalText {
  /* position: relative;
  top: 30px; */
  margin-top:20px;
  margin-bottom:30px;
  font-size: 20px;
  font-weight: 600;
  line-height: 26.6px;
  color: #000000;
}
.okBtn {
  /* position: relative; */
  width: 100%;
  border-radius: 8px;
  /* top: 35px; */
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  padding: 10px;
  /* line-height: 21.28px; */
  margin-bottom: 20px;
}
.cancelBtn {
  /* position: relative; */
  /* top: 40px; */
  width: 100%;
  padding: 10px;
  font-weight: 600;
  /* display: flex; */
  /* justify-content: center; */
  margin: auto;
  color: #000000;
  background: #FFFFFF;
  border: 1px solid #1E90FF;
  border-radius: 8px;
  /* margin-bottom: 30px; */
}

.row {
  display: flex;
}

.frm-group {
  /** display: -webkit-flex;  **/
  display: flex;
  flex-flow: row;
  align-items: left;
  width: 100%;
}

.frm-group label:first-child {
  text-align: left;
  vertical-align: bottom;
  margin: 4px 15px 0px 10px;
  white-space: nowrap;
  width: 80%;
}

.frm-group label::nth-child(2) {
  text-align: right;
  vertical-align: bottom;
  margin: 4px 15px 0px 10px;
  width: 20%;
  white-space: nowrap;
}

.frm-group input[type="text"] {
  vertical-align: left;
  margin: 4px 10px 0px 0px;
  width: 40%;
  padding: 2px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.frm-group input[type="radio"] {
  margin: 4px 0px 0px 10px;
  background-color: #fff;
}

.frm-group select {
  vertical-align: left;
  margin: 4px 10px 0px 0px;
  width: 40%;
  padding: 2px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.column1 {
  flex-flow: row;
  flex: 15%;
  padding: 2px;
  border: 1px solid #ddd;
}

.column2 {
  flex-flow: row;
  flex: 15%;
  padding: 2px;
  border: 1px solid #ddd;
}

.column3 {
  flex: 15%;
  flex-flow: row;
  padding: 2px;
  border: 1px solid #ddd;
}

.column4 {
  flex: 20%;
  flex-flow: row;
  padding: 2px;
  border: 1px solid #ddd;
}

.column5 {
  flex-flow: row;
  flex: 20%;
  padding: 2px;
  border: 1px solid #ddd;
}

.totalbold {
  font-weight: bold;
}

section button {
  display: block;
  padding: 0.5em 1em;
  text-decoration: none;
}

section button:hover {
  color: white;
  background: olivedrab;
}

section ul,
section ul li {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

section>ul {
  text-align: left;
}

section>ul>li {
  display: inline-block;
  border-left: solid 1px
}

.sub-menu-parent:focus,
.sub-menu-parent:hover {
  visibility: visible;
  /* shows sub-menu */
  opacity: 1;
  z-index: 1;
  transform: translateY(0%);
  transition-delay: 0s, 0s, 0.3s;
  /* this removes the transition delay so the menu will be visible while the other styles transition */
}

.sub-menu-parent {
  position: relative;
}

.final-group {
  /** display: -webkit-flex;  **/
  display: flex;
  flex-flow: row;
  align-items: left;
  width: 60%;
}

.final-group label {
  width: 25%;
  text-align: left;
  vertical-align: bottom;
  margin: 4px 15px 0px 10px;
  white-space: nowrap;
}

.input-error {
  border-color: #EA2626 !important;
  color: #EA2626 !important;
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.uploadBtn:disabled {
  cursor: not-allowed;
}
</style>
